import React from "react";
import * as ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals";

import { RecoilRoot } from "recoil";

import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <RecoilRoot>
    <App />
  </RecoilRoot>
);
reportWebVitals();
